module.exports = __webpack_public_path__ + "static/media/focus-cercle.41160103.png";